<template>
  <div class="block-fake-news-question">
    <div class="block-fake-news-question-wrapper">
      <div class="block-fake-news-question-col">
        <div class="content">
          <img class="image" :src="content.getQuestionIcon()" v-if="content.getQuestionIcon().length" alt=""/>
          <div class="content-text">
            <h2 class="title">{{ content.getQuestionTitle() }}</h2>
            <p class="text">{{ content.getQuestionContent() }}</p>
          </div>
        </div>
      </div>
      <div class="block-fake-news-question-col">
        <form
          @submit.prevent="$emit('onSubmit', fakeNewsQuestion)"
          class="form"
        >
      <textarea name="question" rows="3"
                v-model="fakeNewsQuestion"
                :maxlength="content.getMaximumCaracter()"
                :placeholder="content.getQuestionMaxChar()"
                class="c-form__textarea input-error-processed"
      />
          <p class="infos" v-if="fakeNewsQuestion.length > 0">{{fakeNewsQuestion.length}} / {{ content.getMaximumCaracter() }} {{fakeNewsQuestion.length > 1 ?  ' caractères saisis' : ' caractère saisi'}}</p>
          <p class="infos" v-else>{{ content.getMaximumCaracter() }} caractères max</p>
          <p class="error" v-if="showErrorMessage">Une erreur s'est produite, veuillez ré-essayer ultérieurement.</p>

          <div class="form-footer">
            <input class="btn-submit" type="submit" ref="submitButton" label="Envoyer"
                   :disabled="fakeNewsQuestion.length < 1"/>
          </div>
        </form>
      </div>

      <ModalWrapper v-if="displayModal">
        <template #header="{ ariaLabelledby }">
          <button type="button"
                  @click="$emit('onCloseModal')"
                  class="btn-close"
                  aria-label="Fermer">
            <i class="asip-icon icon-cross-out" aria-hidden="true"></i>
          </button>
          <img :src="content.getQuestionPopinIcon()" alt="icon image" v-if="content.getQuestionPopinIcon().length"/>
          <h1 :id="ariaLabelledby">{{ content.getQuestionPopinTitle() }}</h1>
        </template>
        <template #body>
          {{ content.getQuestionPopinContent() }}
        </template>
      </ModalWrapper>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue';
import ModalWrapper from '@/components/sharedComponents/modals/ModalWrapper.component.vue';
import { FakeNewsModel } from '@/models';

export default {
  props: {
    content: {
      type: FakeNewsModel,
      default: () => ({}),
    },
    displayModal: {
      type: Boolean,
      default: false,
    },
    showErrorMessage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalWrapper,
  },
  setup() {
    const fakeNewsQuestion = ref('');

    return {
      fakeNewsQuestion,
    };
  },
};
</script>
